export const sanityConfig = {
  projectId: process.env.GATSBY_SANITY_ID,
  dataset: process.env.GATSBY_SANITY_DATASET,
  token:
    "skBU9iis1D6M9kbgeewnLQ88bRs7YQoMBV5O2c1QDyOTkSvwq6ztwNkpTn169a2gLGRjhdmkMYjhaSv2RtNncVmD7B7dSXmLYeV9z5B0B0b1oVeYY92HhtApg4uoljQ0DgBQBrwQaDDugNd0vw6lpUnsn0b1vlvMSDR6rhYJ5WcvXDu07sLG",
}
